import React from 'react';
import { GlassesIcon } from 'lucide-react';
import { lenses, media } from '../data/product';
import { GuaranteeBadge, GuaranteeStrip, ShopHotspot } from './BannerOverlays';
import { CtaButton } from './CtaButton';
export function LensSection() {
  return <section id="lenses" className="scroll-mt-28 border-b border-white/10 bg-ink-900" data-id="element-609" data-mp="36mr6wtsa5qw0">
      <div className="mx-auto max-w-[1400px] px-4 py-14 sm:px-6 lg:px-8 lg:py-20" data-id="element-610" data-mp="3bhwtlutib9l5">
        <h2 className="grit-headline text-[clamp(2.75rem,11vw,6rem)] font-extrabold uppercase text-offwhite" data-id="element-611" data-mp="2wu222hr8jb9n">
          One frame.
          <br data-id="element-612" data-mp="31nen6hwpgzxn" />
          <span className="text-grit-500" data-id="element-613" data-mp="2nu5dsh8rcef4">Three lenses.</span>
        </h2>
        <p className="mt-4 text-lg font-medium text-steel-300 sm:text-xl" data-id="element-614" data-mp="2ns2hxgkxbr2h">Change the lens. Keep working.</p>

        <figure className="relative mt-10" data-id="element-615" data-mp="2sqvvf907ni2n">
          <img src={media.lensSheet} alt="GritVue X1 shown with its clear, amber and smoke interchangeable lenses and workers using each one" className="block h-auto w-full border border-white/10" data-id="element-616" data-mp="2dvprcrkodtby" />
          <GuaranteeBadge box={{
          left: '16.9%',
          top: '43.9%',
          width: '18.4%',
          height: '11.2%'
        }} data-id="element-617" data-mp="3e2ouxh9jce60" />
          <ShopHotspot box={{
          left: '3.5%',
          top: '46.2%',
          width: '14%',
          height: '7.2%'
        }} data-id="element-618" data-mp="393lp3ulqe3wz" />
          <GuaranteeStrip className="mt-0" data-id="element-619" data-mp="3n0ha8lf9blte" />
        </figure>

        <ul className="mt-6 grid gap-6 lg:grid-cols-3" data-id="element-620" data-mp="3j0qfk6mm0ljl">
          {lenses.map(lens => <li key={lens.name} className="flex h-full flex-col border border-white/10 bg-ink-950 p-6" data-id="element-621" data-mp="2v9bai63g7q4n">
              <span className="h-14 w-24 rounded-[999px_999px_60px_60px] border-2 border-white/25" style={{
            backgroundColor: lens.swatch
          }} aria-hidden="true" data-id="element-622" data-mp="2qc2otvj3d3yn" />
              <h3 className="mt-6 font-display text-4xl font-extrabold uppercase leading-none text-offwhite" data-id="element-623" data-mp="2za4yezgw54xj">
                {lens.name}
              </h3>
              <p className="mt-2 text-xs font-bold uppercase tracking-[0.2em] text-grit-500" data-id="element-624" data-mp="27l1rfbxmdgh7">{lens.use}</p>
              <p className="mt-3 text-[15px] text-steel-400" data-id="element-625" data-mp="aknswcdcbjvo">{lens.body}</p>
            </li>)}
        </ul>

        <p className="mt-8 text-center font-display text-2xl font-bold uppercase tracking-wide text-offwhite" data-id="element-626" data-mp="fhxhjpswnrig">
          The full lens system comes with the Complete System and every multipack.
        </p>
        <p className="mt-2 text-center text-[15px] text-steel-400" data-id="element-627" data-mp="p7h0swkj5ndu">
          Building an X1 Essential? Pick one lens, then add the other two for $9.95.
        </p>

        <a href="#prescription" className="mt-8 flex flex-col items-start gap-4 border-2 border-grit-500 bg-grit-500/10 p-5 transition-colors duration-150 ease-grit hover:bg-grit-500/15 sm:flex-row sm:items-center sm:p-6" data-id="element-628" data-mp="3soz4crt9s88g">
          <GlassesIcon className="h-9 w-9 shrink-0 text-grit-500" aria-hidden="true" data-id="element-629" data-mp="6jlsvtbln3sn" />
          <p data-id="element-630" data-mp="1cxus2kvaji7d">
            <span className="block font-display text-2xl font-extrabold uppercase leading-none text-grit-500 sm:text-3xl" data-id="element-631" data-mp="1d0h0emq0a1qn">
              Prescription ready
            </span>
            <span className="mt-1.5 block text-[15px] font-medium text-steel-200" data-id="element-632" data-mp="32e6wn51opjnp">
              Wear prescription lenses? Take your X1 to your trusted optical professional and ask about a custom
              prescription setup. See both ways to go prescription →
            </span>
          </p>
        </a>

        <p className="grit-headline mt-12 text-center text-[clamp(2rem,7vw,4rem)] font-extrabold uppercase text-offwhite" data-id="element-633" data-mp="2nq2jeglei0cb">
          One frame.
          <br data-id="element-634" data-mp="2eq5r84zsyjci" />
          <span className="text-grit-500" data-id="element-635" data-mp="2epny3h8fsl8t">Every job.</span>
        </p>

        <div className="mt-8 flex justify-center" data-id="element-636" data-mp="29qt5xookxkc1">
          <CtaButton href="#build-your-x1" className="w-full sm:w-auto" data-id="element-637" data-mp="29rm5a4l7l7k5">
            Build your X1
          </CtaButton>
        </div>
      </div>
    </section>;
}